import React, { useEffect, useState } from "react";
import CommunicationMethodListing from "./CommunicationMethodListing";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setPage,
  setRowsPerPage,
  setSearchValue,
  setIsTableLoading,
  setTotalItems,
  setItems,
} from "src/redux/slices/CommunicationMethodSlice";
import AddCommunicationMethodFormWrapper from "../Add/AddCommunicationMethodFormWrapper";
import EditCommunicationMethodWrapper from "../Edit/EditCommunicationMethodWrapper";
import { useGetCommunicationMethodPaginationQuery , useDeleteCommunicationMethodMutation } from "src/services/CommunicationMethodServices";
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";
import { MdDeleteOutline } from "react-icons/md";
import { RxPencil1 } from "react-icons/rx";
import { showToast } from "src/utils/showToaster";
import { UserModuleActionTypes, UserModuleNameTypes } from "src/models/userAccess/UserAccess.model";
import { isCheckColumnPermission } from "src/helpers/userAccessFun";

type Props = {};

const CommunicationMethodListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  //STATE
  const [isOpenAddForm, setIsOpenAddForm] = useState(false);
  const [isOpenEditForm, setIsOpenEditForm] = useState(false);
  const [CommunicationMethodId , setCommunicationMethodId] = useState('') 

  const [deleteCommunication] = useDeleteCommunicationMethodMutation()

  const { items, totalItems, page, rowsPerPage, searchValue, isTableLoading } =
    useSelector((state: RootState) => state.communicationMethod);

  const { data, isLoading, isFetching } =
    useGetCommunicationMethodPaginationQuery({
      limit: rowsPerPage,
      searchValue: searchValue,
      params: ["communication_method", "communication_type"],
      page: page,
      filterBy: [],
      dateFilter: {},
      orderBy: "createdAt",
      orderByValue: -1,
      isPaginationRequired: true,
    });

  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setTotalItems(data?.totalItem || 0));
      dispatch(setIsTableLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);

  const getActionOptions = (row: any) => {
    return [
      {
        label: (
          <div className="flex gap-2 items-center text-secondary-main">
            <RxPencil1 className="text-lg" /> Edit
          </div>
        ),
        onClick: () => {
          setIsOpenEditForm(true)
          setCommunicationMethodId(row?._id)
        },
        moduleName: UserModuleNameTypes.COMMUNICATION_METHOD,
        actionName: UserModuleActionTypes.EDIT,
      },
      {
        label: (
          <div className="flex gap-2 items-center text-red-600 font-semibold">
            <MdDeleteOutline className="text-lg" /> Delete
          </div>
        ),
        onClick: () => {
          showConfirmationDialog({
            title: "Heads Up",
            text: "Are you sure want to Delete this Communication Method ?",
            icon: "question",
            showCancelButton: true,
            next: (result) => {
              if (result.isConfirmed) { 
                deleteCommunication({id:row?._id}).then((res: any) => {
                  if (res?.error) {
                    showToast("error", res?.error?.data?.message);
                  } else {
                    if (res?.data?.status) {
                      showToast("success", res?.data?.message);
                    } else {
                      showToast("error", res?.data?.message);
                    }
                  }
                });
              }
            },
          });
        },
        moduleName: UserModuleNameTypes.COMMUNICATION_METHOD,
        actionName: UserModuleActionTypes.DELETE,
      },
    ];
  };

  const columns: columnTypes[] = [
    {
      field: "communication_method",
      headerName: "Communication Method",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => <span> {row.communication_method} </span>,
    },
    {
      field: "communication_type",
      headerName: "Communication Type",
      extraClasses: "py-2",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => <span> {row?.communication_type} </span>,
    },

    {
      noAuthRequired: true,
      field: "action",
      headerName: "Action",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => {
        const options = getActionOptions(row);
        return <ATMMenu options={options} orientation="vertical" />;
      },
    },
  ];

  return (
    <div>
      <CommunicationMethodListing
        columns={isCheckColumnPermission({
          moduleName: UserModuleNameTypes.COMMUNICATION_METHOD,
          actionName: UserModuleActionTypes.LIST,
          columns: columns
        })}
        rows={items}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
        onAddNew={() => setIsOpenAddForm(true)}
      />
      {isOpenAddForm ? (
        <AddCommunicationMethodFormWrapper
          onClose={() => setIsOpenAddForm(false)}
        />
      ) : null}
      {isOpenEditForm ? (
        <EditCommunicationMethodWrapper 
        communicationId={CommunicationMethodId}
          onClose={() => setIsOpenEditForm(false)}
        />
      ) : null}
    </div>
  );
};

export default CommunicationMethodListingWrapper;
